import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { Events } from '../../firebase/telemetry';


const drawApplicant = async (page, helveticaFont, applicant, offset) => {

    page.drawText(applicant.fullName === undefined ? "" : applicant.fullName, {
        x: 245,
        y: 712 - offset,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        //rotate: degrees(-45),
    })

    page.drawText(applicant.address === undefined ? "" : applicant.address, {
        x: 245,
        y: 697 - offset,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        //rotate: degrees(-45),
    })

    page.drawText(applicant.phNumber === undefined ? "" : applicant.phNumber, {
        x: 245,
        y: 682 - offset,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        //rotate: degrees(-45),
    })

    page.drawText(applicant.minersRightNo === undefined ? "" : applicant.minersRightNo, {
        x: 430,
        y: 681 - offset,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        //rotate: degrees(-45),
    })
}

const groupBy = key => array =>
    array.reduce((objectsByKeyValue, obj) => {
        const value = obj.properties[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});


const drawGraticules = async (page, helveticaFont, graticuleStack) => {


    const groupById = groupBy('primary_no')

    const workableStack = groupById(graticuleStack.features);
    //const keyArray = Object.keys(workableStack)
    //for (let i = 0; i < keyArray.length; i++) {
    let i = 0
    for (const col in workableStack) {
        page.drawText(col, {
            x: 172,
            y: 500 - (i * 8),
            size: 7,
            font: helveticaFont,
            color: rgb(0, 0, 0),
        })

        page.drawText(workableStack[col].map(e => e.properties.block_no).join(','), {
            x: 272,
            y: 500 - (i * 8),
            size: 7,
            font: helveticaFont,
            color: rgb(0, 0, 0),
        })
        i++;
    }
}


const drawVehicles = async (page, helveticaFont, vehicleStack) => {

    for (let i = 0; i < vehicleStack.length; i++) {
        page.drawText(vehicleStack[i].make === undefined ? "" : vehicleStack[i].make, {
            x: 143,
            y: 342 - (i * 9),
            size: 8,
            font: helveticaFont,
            color: rgb(0, 0, 0),
        })

        page.drawText(vehicleStack[i].model === undefined ? "" : vehicleStack[i].model, {
            x: 247,
            y: 342 - (i * 9),
            size: 8,
            font: helveticaFont,
            color: rgb(0, 0, 0),
        })

        page.drawText(vehicleStack[i].rego === undefined ? "" : vehicleStack[i].rego, {
            x: 365,
            y: 342 - (i * 9),
            size: 8,
            font: helveticaFont,
            color: rgb(0, 0, 0),
        })
    }


}

export async function Generate40EPermit(permitData) {

    const existingPdfBytes = await fetch('/minerals-form1a.pdf', { method: 'GET' }).then((res) => { return res.arrayBuffer() });

    const pdfDoc = await PDFDocument.load(existingPdfBytes)

    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

    // Get the first page of the document
    const pages = pdfDoc.getPages()
    const firstPage = pages[0]

    // Get the width and height of the first page
    const { width, height } = firstPage.getSize()

    await drawApplicant(firstPage, helveticaFont, permitData.applicant1, 0)

    await drawApplicant(firstPage, helveticaFont, permitData.applicant2, 47)

    await drawApplicant(firstPage, helveticaFont, permitData.applicant3, 93)


    firstPage.drawText(permitData.tenement.properties.fmt_tenid, {
        x: 220,
        y: 545,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    })


    await drawGraticules(firstPage, helveticaFont, permitData.graticuleStack)

    let holdersArrr = permitData.tenement.properties.holdername.split(";");

    firstPage.drawText(holdersArrr[0], {
        x: 130,
        y: 423,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    })
    firstPage.drawText(permitData.tenement.properties.holderaddr, {
        x: 120,
        y: 412,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    })

    if(holdersArrr[1]) {
    
        firstPage.drawText(holdersArrr[1], {
            x: 130,
            y: 401,
            size: 9,
            font: helveticaFont,
            color: rgb(0, 0, 0),
        })
        firstPage.drawText(permitData.tenement.properties.holderaddr, {
            x: 120,
            y: 390,
            size: 9,
            font: helveticaFont,
            color: rgb(0, 0, 0),
        })
    }

    await drawVehicles(firstPage, helveticaFont, permitData.vehicleStack)

    firstPage.drawText(permitData.applicant1.address, {
        x: 120,
        y: 160,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    })

    // Serialize the PDFDocument to bytes (a Uint8Array)
    const pdfBytes = await pdfDoc.save()


    Events.permit40EGenerated();

    const url = window.URL.createObjectURL(new Blob([pdfBytes]));
    const link = document.createElement("a");
    link.href = url;
    link.download = "form1A.pdf";
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
